import { Alert, AlertProps, Snackbar } from "@mui/material";

import {
  createContext,
  ReactNode,
  useState,
  useContext,
  useCallback,
} from "react";

interface INotificationProvider {
  handleNotification: (
    type: AlertProps["severity"],
    message: string,
    duration?: number
  ) => void;
}
interface INotification {
  type: AlertProps["severity"];
  message: string;
  duration?: number;
}

export const NotificationContext = createContext<INotificationProvider>(
  {} as INotificationProvider
);

export const NotificationProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const [notification, setNotification] = useState<INotification | null>(null);

  const handleNotification: INotificationProvider["handleNotification"] =
    useCallback(
      (type, message, duration = 6000) =>
        setNotification({ type, message, duration }),
      []
    );

  return (
    <NotificationContext.Provider
      value={{
        handleNotification,
      }}
    >
      <Snackbar
        open={!!notification?.type}
        autoHideDuration={notification?.duration}
        onClose={() => setNotification(null)}
      >
        {notification?.type && (
          <Alert
            onClose={() => setNotification(null)}
            severity={notification?.type}
            sx={{ width: "100%" }}
          >
            {notification?.message}
          </Alert>
        )}
      </Snackbar>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
